import { render, staticRenderFns } from "./MyDirectoryTalent.vue?vue&type=template&id=d9bb7690"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9bb7690')) {
      api.createRecord('d9bb7690', component.options)
    } else {
      api.reload('d9bb7690', component.options)
    }
    module.hot.accept("./MyDirectoryTalent.vue?vue&type=template&id=d9bb7690", function () {
      api.rerender('d9bb7690', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/MyDirectoryTalent.vue"
export default component.exports